import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'

import Header from '../components/Header'
import Footer from '../components/Footer'
import Logo from '../components/Logo'
import Button from '../components/Button'
import RequestCard from '../components/RequestCard/RequestCard'

import infinityText from '../animation/infiniteText'

const requestProps = {
    price: {
        from: '10000',
        to: '15000',
    },
    peopleCount: 1,
    roomsCount: 1,
    location: 'Местоположение',
    rentTime: {
        from: '06.01.23',
        to: '11.01.23'
    },
    checkInTime: {
        from: '12:00',
        to: '14:00'
    },
    landlord: {
        name: 'Анита Б.',
        img: '/images/landlord.png',
        rating: '4.8'
    },
    included: [
        'Wi-Fi',
        'TV',
        'Кондиционер',
        'Парковка',
    ]
}

const Home = () => {

    useEffect(() => {
        infinityText('.scroll-line', '.scroll-elem')
    }, [])

    return (
        <>
            <Helmet>
                <title>Главная - 2stay</title>
            </Helmet>

            <Header/>

            <div className='absolute top-0 left-0 w-full h-full bg-primary-400 z-[-1]'></div>
            <main>
                <section className='relative min-h-[100vh] pt-36 pb-24 flex items-center text-white'>
                    <img src='/images/home-gradient.svg' className='absolute top-0 left-0 z-[-1]' width='933' height='1031' alt='gradient' />
                    <img src='/images/home-circle.png' className='absolute top-0 right-0 z-[-1]' width='741' height='618' alt='gradient' />
                    <div className='container-lg flex items-center'>
                        <div className='flex flex-col'>
                            <Logo className='w-52 h-20 pointer-events-none' />
                            <h1 className='heading mb-11'>Жильё которое ищет тебя</h1>
                            <Button className='btn-white flex items-center'>
                                <svg className='mr-1.5' width='17' height='11' viewBox='0 0 17 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                    <mask id='mask0_294_568' style={{'mask-type':'alpha'}} maskUnits='userSpaceOnUse' x='0' y='0' width='17' height='11'>
                                        <path fill-rule='evenodd' clip-rule='evenodd' d='M11 11H5.5C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0H11C14.0376 0 16.5 2.46243 16.5 5.5C16.5 8.53757 14.0376 11 11 11ZM5.5 1.375C4.02628 1.375 2.66451 2.16122 1.92765 3.4375C1.19078 4.71378 1.19078 6.28622 1.92765 7.5625C2.66451 8.83878 4.02628 9.625 5.5 9.625H11C13.2782 9.625 15.125 7.77817 15.125 5.5C15.125 3.22183 13.2782 1.375 11 1.375H5.5ZM5.5 8.25C3.98122 8.25 2.75 7.01878 2.75 5.5C2.75 3.98122 3.98122 2.75 5.5 2.75C7.01878 2.75 8.25 3.98122 8.25 5.5C8.25 6.22935 7.96027 6.92882 7.44454 7.44454C6.92882 7.96027 6.22935 8.25 5.5 8.25ZM5.5 4.125C4.74061 4.125 4.125 4.74061 4.125 5.5C4.125 6.25939 4.74061 6.875 5.5 6.875C6.25939 6.875 6.875 6.25939 6.875 5.5C6.875 4.74061 6.25939 4.125 5.5 4.125Z' fill='white'/>
                                    </mask>
                                    <g mask='url(#mask0_294_568)'>
                                        <rect y='-2.75' width='16.5' height='16.5' fill='#6B32EA'/>
                                    </g>
                                </svg>
                                Дополнительные настройки
                            </Button>
                            <p className='mt-32 mb-14 max-w-[469px]'>
                                Короткая текстовая информация о сервисе и приложении, о том для кого оно, и какие функции покрывает 
                            </p>
                            <Link to='#' target='_blank'>
                                <img src='/icons/google-play-badge.svg' alt='google play badge' width='162' height='48' />
                            </Link>
                        </div>
                        <img src='/images/home-building.png' className='ml-auto' alt='building illustration' width='533' height='702' />
                        <img src='/icons/down-icon.svg' className='absolute bottom-10 left-1/2 -translate-x-1/2' alt='down icon' width='24' height='24' />
                    </div>
                </section>

                <section className='pt-16 pb-96 text-white overflow-hidden'>
                    <div className='container'>
                        <h2 className='heading text-center mb-11'>О добавлении заявок</h2>
                        <p className='max-w-[733px] mx-auto mb-20'>
                            Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации 'Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст..'
                        </p>
                    </div>
                    <div className='w-full h-fit grid grid-cols-1 gap-6'>
                        {
                            [...Array(2)].map(() => {
                                return (
                                    <div className='scroll-line flex flex-nowrap w-[max-content]'>
                                        {
                                            [...Array(6)].map(() => {
                                                return (
                                                    <RequestCard 
                                                        className='scroll-elem mr-5'
                                                        {...requestProps}
                                                    />
                                                )
                                            })
                                        }   
                                    </div>
                                )
                            })
                        }
                    </div>
                </section>
                <section className='text-white pb-[394px]'>
                    <div className='container'>
                        <h2 className='heading text-center mb-11'>Информация</h2>
                        <p className='max-w-[767px] mx-auto'>
                            Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации 'Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст..'
                        </p>
                    </div>
                </section>
                <section  className='bg-white text-black pb-48'>
                    <div className='container relative pt-[330px]'>
                        <div className='absolute -top-[250px] left-0 w-full px-36 py-32 bg-yellow-400 rounded-[30px]'>
                            <div className='max-w-[349px]'>
                                <h2 className='heading mb-4'>Call to action</h2>
                                <p className='mb-11'>Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому</p>
                                <Button className='btn-white flex items-center'>
                                    <svg className='mr-1.5' width='17' height='11' viewBox='0 0 17 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <mask id='mask0_294_568' style={{'mask-type':'alpha'}} maskUnits='userSpaceOnUse' x='0' y='0' width='17' height='11'>
                                            <path fill-rule='evenodd' clip-rule='evenodd' d='M11 11H5.5C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0H11C14.0376 0 16.5 2.46243 16.5 5.5C16.5 8.53757 14.0376 11 11 11ZM5.5 1.375C4.02628 1.375 2.66451 2.16122 1.92765 3.4375C1.19078 4.71378 1.19078 6.28622 1.92765 7.5625C2.66451 8.83878 4.02628 9.625 5.5 9.625H11C13.2782 9.625 15.125 7.77817 15.125 5.5C15.125 3.22183 13.2782 1.375 11 1.375H5.5ZM5.5 8.25C3.98122 8.25 2.75 7.01878 2.75 5.5C2.75 3.98122 3.98122 2.75 5.5 2.75C7.01878 2.75 8.25 3.98122 8.25 5.5C8.25 6.22935 7.96027 6.92882 7.44454 7.44454C6.92882 7.96027 6.22935 8.25 5.5 8.25ZM5.5 4.125C4.74061 4.125 4.125 4.74061 4.125 5.5C4.125 6.25939 4.74061 6.875 5.5 6.875C6.25939 6.875 6.875 6.25939 6.875 5.5C6.875 4.74061 6.25939 4.125 5.5 4.125Z' fill='white'/>
                                        </mask>
                                        <g mask='url(#mask0_294_568)'>
                                            <rect y='-2.75' width='16.5' height='16.5' fill='#6B32EA'/>
                                        </g>
                                    </svg>
                                    Дополнительные настройки
                                </Button>
                            </div>
                            <img src="/images/phone.png" className='absolute bottom-0 right-24' alt="phone" width='335' height='573' />
                        </div>
                        <div className='grid grid-cols-2 gap-y-17 max-w-[767px] mx-auto'>
                            <div className='flex flex-col max-w-[348px]'>
                                <h3 className='heading text-center mb-16'>Гость</h3>
                                <img src="/images/circle.svg" className='rounded-full object-cover mx-auto mb-14' alt="circle" width='104' height='104'  />
                                <p className='mb-20'>
                                    Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации "Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст.."
                                </p>
                                <Button className='btn-purple'>Создать аккаунт</Button>
                            </div>
                            <div className='flex flex-col max-w-[348px]'>
                                <h3 className='heading text-center mb-16'>Владелец</h3>
                                <img src="/images/circle.svg" className='rounded-full object-cover mx-auto mb-14' alt="circle" width='104' height='104'  />
                                <p className='mb-20'>
                                    Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться. Lorem Ipsum используют потому, что тот обеспечивает более или менее стандартное заполнение шаблона, а также реальное распределение букв и пробелов в абзацах, которое не получается при простой дубликации "Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст.."
                                </p>
                                <Button className='btn-purple'>Создать аккаунт</Button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </>
    )
}

export default Home